export default function Hero() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/80 via-background-50 to-accent-50/60"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4 whitespace-nowrap">
              每日更新 · 全网大赛吃瓜一站式入口
            </span>
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-foreground-950 leading-tight mb-6">
              吃瓜入口
              <br />
              <span className="text-primary-500">每日大赛</span>
              精彩爆料直达
            </h1>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-2">
              汇集每日大赛最新视频、独家爆料与系列追踪内容，入口每日更新，大赛吃瓜在线观看一站直达。
            </p>
            <p className="text-foreground-500 text-sm leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              无论你是追更每一期综艺选秀的内幕花絮，还是关注电竞赛场上的选手动态与转会风波，吃瓜入口为你整理最新、最全的大赛吃瓜信息，不再错过任何一期精彩。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-8">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
                <span className="text-xs md:text-sm text-foreground-600 whitespace-nowrap">
                  今日已更新 <strong className="text-primary-500">38</strong> 条内容
                </span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-eye-line text-accent-500 text-sm"></i>
                <span className="text-xs md:text-sm text-foreground-600 whitespace-nowrap">
                  覆盖 <strong className="text-primary-500">12</strong> 档热门大赛
                </span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-shield-check-line text-accent-500 text-sm"></i>
                <span className="text-xs md:text-sm text-foreground-600 whitespace-nowrap">
                  内容来源严格核实
                </span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                onClick={(e) => handleScroll(e, '#carousel')}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-white rounded-full font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors duration-200 text-center"
              >
                立即吃瓜
              </a>
              <a
                href="#updates"
                onClick={(e) => handleScroll(e, '#updates')}
                className="w-full sm:w-auto px-8 py-3 border-2 border-background-300 text-foreground-700 rounded-full font-medium text-sm whitespace-nowrap cursor-pointer hover:border-primary-300 hover:text-primary-500 transition-colors duration-200 text-center"
              >
                浏览最新动态
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative w-full aspect-[4/5] max-h-[600px] overflow-hidden rounded-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=A%20stylized%20editorial%20illustration%20of%20a%20modern%20news%20aggregation%20portal%20with%20floating%20breaking%20news%20elements%2C%20warm%20coral%20and%20amber%20color%20palette%2C%20abstract%20geometric%20shapes%20representing%20media%20and%20gossip%20content%2C%20clean%20minimalist%20composition%20with%20dynamic%20energy%2C%20editorial%20design%20aesthetic%2C%20soft%20gradients%20and%20layered%20transparency%20effects%2C%20professional%20yet%20playful%20tone%2C%20high%20contrast%20between%20warm%20accents%20and%20neutral%20background&width=800&height=1000&seq=hero-chigua-2026&orientation=portrait"
                alt="吃瓜入口 - 每日大赛吃瓜内容聚合平台"
                className="w-full h-full object-cover object-top"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}